import React, { SVGProps } from 'react';

const SvgLeaderboard = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none" {...props}>
			<g clip-path="url(#clip0_6196_306)">
				<path d="M6.66659 11.0834V14.25M13.3333 9.50004V14.25M9.99992 6.33337V14.25M16.6666 5.38337V13.6167C16.6666 14.9469 16.6666 15.6119 16.3941 16.12C16.1544 16.5669 15.772 16.9301 15.3016 17.1578C14.7668 17.4167 14.0668 17.4167 12.6666 17.4167H7.33325C5.93312 17.4167 5.23305 17.4167 4.69828 17.1578C4.22787 16.9301 3.84542 16.5669 3.60574 16.12C3.33325 15.6119 3.33325 14.9469 3.33325 13.6167V5.38337C3.33325 4.05325 3.33325 3.38818 3.60574 2.88015C3.84542 2.43326 4.22787 2.06993 4.69828 1.84223C5.23305 1.58337 5.93312 1.58337 7.33325 1.58337H12.6666C14.0668 1.58337 14.7668 1.58337 15.3016 1.84223C15.772 2.06993 16.1544 2.43326 16.3941 2.88015C16.6666 3.38818 16.6666 4.05325 16.6666 5.38337Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
			</g>
			<defs>
				<clipPath id="clip0_6196_306">
					<rect width="20" height="19" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgLeaderboard;
